import React from "react";
import { useIntl } from "react-intl";
import { ContentTextInputCard } from "crossdock/common/flow/cards/ContentTextInputCard";
import { DIMS_AND_WEIGHT_LABELS } from "crossdock/modes/inspection/labels";
import { useCrossdockDimsAndWeightScanPackageCdsku } from "crossdock/modes/inspection/crossdock-dims-and-weight/cards/ScanPackageCdskuCard/useCrossdockDimsAndWeightScanPackageCdsku";

export const CrossdockDimsAndWeightScanPackageCdskuCard: React.FC = () => {
  const { cdsku, submitPackageCdsku, onPackageCdskuChange, loading, errorMessage } =
    useCrossdockDimsAndWeightScanPackageCdsku();
  const { formatMessage } = useIntl();

  return (
    <ContentTextInputCard
      onSubmit={submitPackageCdsku}
      title={formatMessage(DIMS_AND_WEIGHT_LABELS.scanPackageCdskuCardTitle)}
      onChange={onPackageCdskuChange}
      value={cdsku}
      disabled={loading}
      errorMessage={errorMessage}
      placeholder={formatMessage(DIMS_AND_WEIGHT_LABELS.packageCdsku)}
      icon="scan"
      accentColor="BLUE"
    />
  );
};
